//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { isLike2BuyV2SubPageParams } from '@insights/insightsSidebarConstants';
import { ICuralateStore } from '@models/AppState';
import { isDefined } from '@utils/filterPredicates';

export const getInsightsMetadata = (state: ICuralateStore) =>
  state.insights.metadata;

export const getHasInsightsMetadataError = createSelector(
  getInsightsMetadata,
  (insightsMetadata) => !!insightsMetadata.errors.fetchMetadataError,
);

export const getHasFetchedMetadata = createSelector(
  getInsightsMetadata,
  (insightsMetadata) => insightsMetadata.flags.hasFetchedMetadata,
);

export const getInsightsCurrency = createSelector(
  getInsightsMetadata,
  (insightsMetadata) => insightsMetadata.currency,
);

export const getInsightsMetadataError = createSelector(
  getInsightsMetadata,
  (insightsMetadata) => insightsMetadata.errors.fetchMetadataError,
);

export const getInsightsMetadataFlags = createSelector(
  getInsightsMetadata,
  (metadata) => metadata.flags,
);

export const getHasFetchedInsightsMetadata = createSelector(
  getInsightsMetadataFlags,
  (flags) => flags.hasFetchedMetadata,
);

export const getClientCreatedOnDate = createSelector(
  getInsightsMetadata,
  (metadata) => metadata.createdOn,
);

export const getInsightsDateRange = createSelector(
  getInsightsMetadata,
  (metadata) => metadata.dateRange,
);

export const getComparisonDateRange = createSelector(
  getInsightsMetadata,
  (metadata) => metadata.comparisonDateRange,
);

export const getInsightsCurrentParams = createSelector(
  getInsightsMetadata,
  (metadata) => metadata.currentStateAndParams?.params,
);

export const getLike2BuyV2InsightsStoreId = createSelector(
  getInsightsCurrentParams,
  (params) =>
    isDefined(params) && isLike2BuyV2SubPageParams(params)
      ? params.storeId
      : undefined,
);
